import React from "react";
import { motion } from "framer-motion";

const Cta = ({heading="", desc=""}) => {

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 45,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <>
      <section className="cta-section">

        {/* OVERLAY */}

        <motion.div
          className="cta-overlay"
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          transition={{
            duration: 1.2,
            ease: "easeOut",
          }}
          viewport={{
            once: true,
          }}
        />

        <motion.div
          className="container cta-container"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.3,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.16,
              },
            },
          }}
        >

          {/* HEADING */}

          <motion.h2 variants={fadeUp}>
           { heading || "Ready for a smooth & Hassle-Free Settlement?"}
          </motion.h2>

          {/* TEXT */}

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            { desc || "Let our experienced settlement team handle the process with accuracy, transparency, and personalised support — ensuring your property transaction is completed smoothly from start to finish."}
          </motion.p>

          {/* BUTTONS */}

          <motion.div
            className="cta-btn-wrap"
            variants={fadeUp}
          >

            <motion.a
            href="/get-a-quote"
              className="primary-btn"
              whileHover={{
                y: -4,
                scale: 1.03,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              Get a Quote
            </motion.a>

            <motion.a
            href="/contact-us"
              className="secondary-btn"
              whileHover={{
                y: -4,
                scale: 1.03,
              }}
              whileTap={{
                scale: 0.97,
              }}
              transition={{
                duration: 0.3,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              Contact us
            </motion.a>

          </motion.div>

        </motion.div>

      </section>
    </>
  );
};

export default Cta;